import { createContext, useContext, type ReactNode } from 'react'

const NONE: ReadonlySet<string> = new Set()

const UpdatedBelowContext = createContext<ReadonlySet<string>>(NONE)

/** The load keys of an answer block whose state a newer block changed: their rows are dimmed and say "Updated below ↓". */
export const UpdatedBelowProvider = ({ keys, children }: { keys: ReadonlySet<string>; children: ReactNode }) => (
    <UpdatedBelowContext.Provider value={keys}>{children}</UpdatedBelowContext.Provider>
)

/** Whether a row's load changed in a newer answer block, so this older row is dimmed. */
export const useUpdatedBelow = (key: string | undefined): boolean => {
    const keys = useContext(UpdatedBelowContext)
    return key !== undefined && keys.has(key)
}
